import { render, staticRenderFns } from "./shipmentreport_ksa.vue?vue&type=template&id=34901f0f&"
import script from "./shipmentreport_ksa.vue?vue&type=script&lang=js&"
export * from "./shipmentreport_ksa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports